//@ts-nocheck

import React, { useEffect } from 'react';
import { 
  Box, 
  Text, 
  Button, 
  Flex, 
  VStack, 
  Grid, 
  ChakraProvider 
} from '@chakra-ui/react';
import { IconLeaf } from '@tabler/icons-react';
import { kStyleGlobal } from '../../../theme';

import {Header} from '../../components/Header';
import {Footer} from '../../components/Footer';
import {ServiceCard} from '../../components/ServiceCard';
//import ClientLogo from '../../components/ClientLogo';
import {TestimonialCard} from '../../components/TestimonialCard';
import { HeroSection } from '../../components/HeroSection';
import LogoCarousel from '../../components/LogoCarousel';

const DefaultScreen = () => {

 useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);




const about=[
  {
      "title": "",
      "description":
      "At Lions Forge Contracting, we're a dedicated team passionate about delivering reliable, high-quality contracting services across Canada. Specializing in Demolition, Renovation, Janitorial & Manpower solutions, we combine expertise with a personal touch to bring your projects to life-safely, efficiently, and on schedule .We believe every project is a partnership built on trust, clear communication, and commitment. Our strength lies not only in our skills but in our genuine care for our clients and their goals. When you work with Lions Forge, you're choosing a partner who stands with you every step of the way, ready to deliver results that last.",
      "image":"/home (6).png",    
      
         link: "/about",
    },
];



  const services = [
   {
  "title": "Demolition Services",
  "description": "Our demolition services provide safe, efficient, and eco-friendly solutions for residential, commercial, and industrial projects. We ensure complete site clearance, proper waste disposal, and strict compliance with safety standards to prepare your property for renovation or redevelopment.",
  "image": "/home (2).png",
  "bullets": [
    "Safe and controlled demolition for all property types",
    "Debris removal and eco-friendly waste management",
    "Compliance with local safety and environmental regulations"
  ],
   link: "/services/demolition",
},

   
   {
    "title": "Renovation Services",
    "description": "We provide complete renovation solutions for residential and commercial spaces. From minor upgrades to full-scale remodeling, our skilled team ensures your property is modern, functional, and aesthetically pleasing. We focus on quality craftsmanship and timely project delivery.",
    "image": "/home (3).png",
    "bullets": [
      "Full home and office remodeling",
      "Kitchen and bathroom upgrades",
      "Custom interior and exterior renovations"
    ],
     link: "/services/renovation",
  },
  {
    "title": "Janitorial Services",
    "description": "Our janitorial services keep your workspace, building, or facility clean and well-maintained. We offer reliable daily, weekly, and monthly cleaning packages to ensure a hygienic environment for employees, customers, and residents.",
    "image": "/home (1).png",
    "bullets": [
      "Daily, weekly, and monthly cleaning schedules",
      "Floor, window, and restroom cleaning",
      "Eco-friendly cleaning products and methods"
    ],
     link: "/services/janitors",
  },
  {
    "title": "Post-construction Cleaning",
    "description": "After a construction or renovation project, our professional cleaning team ensures your space is spotless and ready to use. We handle dust, debris, and residue removal with care, leaving your property fresh, safe, and move-in ready.",
    "image": "/home (4).png",
    "bullets": [
      "Dust and debris removal",
      "Deep cleaning of floors, walls, and windows",
      "Safe disposal of construction waste"
    ],
      link: "/services/cleaning",
  },
  {
    "title": "Manpower Supply",
    "description": "We specialize in providing fast, reliable warehouse labour to keep your operations efficient and productive. Whether you're managing daily operations or handling peak demand, we supply experienced workers ready to step in and perform.",
    "image": "/home (5).png",
    "bullets": [
      "Skilled and unskilled labor supply",
      "Flexible short-term and long-term contracts",
      "Reliable workforce for multiple industries"
    ],
       link: "/services/manpower",
  }
  ];

  const testimonials = [
    {
      "quote": "This company quoted me the best price for my junk removal at my rental property. The crew was very punctual, helpful and super fast . I would definitely hire them again for the future again .",
      "author": "Naveet Somal",
      "position": "Property Manager, Ramco Properties",
      "image": "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=2069&auto=format&fit=crop"
    },
    {
      "quote": "Flexibility was great as I had to change my timing. Communication beforehand and day of was great. They arrived on time and had everything out in no time. Price was slightly higher than I expected but fair given size of items I had removed. Very friendly and respectful. I will use again in a heartbeat.",
      "author": "Maureen C",
      "position": "Building Manager, FirstService",
      "image": "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076&auto=format&fit=crop"
    },
    {
      "quote": "This company quoted me the best price for my junk removal at my rental property. The crew was very punctual, helpful and super fast . I would definitely hire them again for the future again.",
      "author": "Naveet Somal",
      "position": "Facilities Director, Acondo Group",
      "image": "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2070&auto=format&fit=crop"
    }
  ];

  const clients = [
    {
      "name": "Ramco",
      "logo": "https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?q=80&w=2069&auto=format&fit=crop"
    },
    {
      "name": "FirstService",
      "logo": "https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?q=80&w=2069&auto=format&fit=crop"
    },
    {
      "name": "Acondo Group",
      "logo": "https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?q=80&w=2069&auto=format&fit=crop"
    },
    {
      "name": "ESA",
      "logo": "https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?q=80&w=2069&auto=format&fit=crop"
    }
  ];

  const sustainabilityPoints = ["Green Products","Waste Reduction","Energy Conservation","Water Management","Sustainable Training"];

  return (
    <ChakraProvider theme={kStyleGlobal}>
      <Box bg="gray.50" minHeight="100vh">
        {/* <Header /> */}
        <HeroSection/>

         
        
        <Box  px={4}>
          <Box textAlign="center" mb={2}>
            <Text fontSize="4xl" fontWeight="bold" mb={2}>
          Our Expertise
            </Text>
            <Box width="60px" height="4px" bg="#B67300" mx="auto" mb={6} />
          </Box>
          
      {services.map((service, index) => (
  <ServiceCard
    key={service.title}
    title={service.title}
    description={service.description}
    imageSrc={service.image}
    bulletPoints={service.bullets}
    reverse={index % 2 !== 0}
    link={service.link}   // even index -> false, odd index -> true
  />
))}

        </Box>


 <Box py={16} px={4}>
          <Box textAlign="center" mb={16}>
            <Text fontSize="4xl" fontWeight="bold" mb={2}>
              
              Who We Are
            </Text>
            <Box width="60px" height="4px" bg="#B67300" mx="auto" mb={6} />
          </Box>
          
      {about.map((service, index) => (
  <ServiceCard
    key={service.title}
    title={service.title}
    description={service.description}
    imageSrc={service.image}
    bulletPoints={service.bullets}
    link={service.link}
    // reverse={index % 2 !== 0}   // even index -> false, odd index -> true
  />
))}

        </Box>
        
        {/* <Box bg="black" py={16} px={4} textAlign="center">
          <Text fontSize="3xl" fontWeight="bold" mb={6}>
            Industries Hiring
          </Text>
          <Button bg="#f05a28" color="white" px={6} py={3} borderRadius="md">
            LEARN MORE
          </Button>
        </Box> */}
        
        {/* <Box py={16} px={4} maxWidth="1200px" mx="auto">
          <Flex 
            direction={["column", "row"]} 
            gap={8} 
            alignItems="center"
          >
            <Box width={["100%", "40%"]}>
              <img
                src="https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?q=80&w=2070&auto=format&fit=crop"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  objectFit: "cover",
                  height: "400px"
                }}
                alt="Sustainability"
              />
            </Box>
            
            <Box width={["100%", "60%"]}>
              <Text fontSize="3xl" fontWeight="bold" mb={4}>
                Our Sustainability Journey
              </Text>
              
              <Text mb={6}>
                At Forever Group, we're committed to environmentally responsible practices that make a positive impact on our planet. Our sustainability initiatives focus on reducing our carbon footprint while delivering exceptional service.
              </Text>
              
              <VStack align="start" spacing={3} mb={6}>
                {sustainabilityPoints.map(point => (
                  <Flex alignItems="center" key={point}>
                    <IconLeaf size={20} color="#f05a28" style={{ marginRight: '8px' }} />
                    <Text>{point}</Text>
                  </Flex>
                ))}
              </VStack>
              
              <Button
                variant="outline"
                borderColor="#f05a28"
                color="#f05a28"
                px={4}
                py={2}
              >
                READ MORE
              </Button>
            </Box>
          </Flex>
        </Box> */}
{/* <Box py={16} px={4} maxWidth="1200px" mx="auto">
          <Text
            fontSize="3xl"
            fontWeight="bold"
            textAlign="center"
            //mb={4}
          >
            Our Clients
          </Text>
          
          {/* <Grid
            templateColumns={["repeat(2, 1fr)", "repeat(4, 1fr)"]}
            gap={6}
          >
            {clients.map(client => (
              <ClientLogo
                key={client.name}
                logoSrc={client.logo}
                name={client.name}
              />
            ))}
          </Grid>   */}
      
        {/* </Box>   */} 
        {/* <LogoCarousel/> */}
        
     

  {/* <Box textAlign="center" mb={12}>
    <Text
      fontSize="3xl"
      fontWeight="bold"
      color="white"
    >
   
    </Text>
  </Box> */}

  {/* <Grid
    templateColumns={["1fr", "repeat(3, 1fr)"]}
    gap={6}
    maxWidth="1200px"
    mx="auto"
    position="relative"
   
  >
    {testimonials.map((testimonial) => (
      <TestimonialCard
        key={testimonial.author}
        quote={testimonial.quote}
        author={testimonial.author}
        position={testimonial.position}
        imageSrc={testimonial.image}
      />
    ))}
  </Grid> */}
  <Grid>

     <Box w="100%" py={10}>
   <div class="elfsight-app-9f747331-a045-43e7-a508-85b575f37031" data-elfsight-app-lazy></div>   </Box>

  </Grid>


        {/* <Footer /> */}
      </Box>
    </ChakraProvider>
  );
};

export default DefaultScreen;
